import React from 'react';
import Dashboard from './Dashboard';

export default function AdjustPermissionsDashboard() {
  return (
    <Dashboard
      dashboardType="ADJUST_PERMISSIONS"
      editable={false}
      defaultOrgaGridJson={orgaGridJson}
      defaultOrgaPanelsJson={orgaPanelsJson}
      defaultUserGridJson={null}
      defaultUserPanelsJson={null}
    />
  );
}

const orgaGridJson = {
  lg: [
    {
      w: 12,
      h: 8,
      x: 0,
      y: 0,
      i: 'ArticleDataZones_54A0-Toez8',
      minH: 1,
      moved: false,
      static: false,
      isDraggable: true
    }
  ],
  md: [
    {
      w: 12,
      h: 8,
      x: 0,
      y: 0,
      i: 'ArticleDataZones_54A0-Toez8',
      minH: 1,
      moved: false,
      static: false,
      isDraggable: true
    }
  ],
  sm: [
    {
      w: 6,
      h: 6,
      x: 0,
      y: 0,
      i: 'ArticleDataZones_54A0-Toez8',
      minH: 1,
      moved: false,
      static: false,
      isDraggable: true
    }
  ]
};

const orgaPanelsJson = {
  'ArticleDataZones_54A0-Toez8': {
    i: 'ArticleDataZones_54A0-Toez8',
    panelType: 'ArticleDataZones',
    configuration: {
      titleVisible: true,
      closable: false,
      movable: false,
      resizableX: false,
      resizableY: true
    }
  }
};
